import { useEffect, useState } from "react";

const ANIMATION_DURATION = 350;

export function useFormAnimation() {
  const [hasAnimated, setHasAnimated] = useState<boolean>(false);

  useEffect(() => {
    if (hasAnimated) return;

    const startTime = performance.now();

    const checkAnimationComplete = () => {
      if (performance.now() - startTime >= ANIMATION_DURATION) {
        setHasAnimated(true);
      } else {
        requestAnimationFrame(checkAnimationComplete);
      }
    };

    const frameId = requestAnimationFrame(checkAnimationComplete);
    return () => cancelAnimationFrame(frameId);
  }, [hasAnimated]);

  return hasAnimated;
}
